import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import {
  Typography,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
} from "@mui/material";
import ApiLoader from "../components/ApiLoader";
import UserMenu from "../components/UserMenu";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import API_BASE_URL from "../utilities/ApiConfig"; // Ensure API_BASE_URL is correctly set

const ListOfScanDocumentsDatewise = () => {
  debugger;
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [scannedData, setScannedData] = useState([]);
  const [notScannedData, setNotScannedData] = useState([]);

  const handleFetchData = async () => {
    if (!fromDate || !toDate) {
      setError("Please select both From Date and To Date.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `${API_BASE_URL}/ScanDocument/GetScannedUnscannedFiles`,
        {
          params: {
            dcode: "04",
            srocode: "02",
            fromdate: fromDate,
            todate: toDate,
          },
        }
      );

      setScannedData(response.data.Table || []);
      setNotScannedData(response.data.Table1 || []);
    } catch (err) {
      setError("Failed to load data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const theme = createTheme({
    typography: { fontFamily: "Poppins" },
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: "#CACACA",
            color: "#000",
            fontWeight: "bold",
            textAlign: "center",
          },
          body: { textAlign: "center" },
        },
      },
    },
  });

  //
  const renderTable = (title, data, isScanned) => (
    <Grid item xs={12} md={6}>
      <Typography
        variant="h6"
        align="center"
        style={{ color: isScanned ? "green" : "red", fontWeight: "bold" }}
      >
        {title}
      </Typography>
      <Paper elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <TableContainer
          sx={{
            maxHeight: {
              xs: 250, // Mobile
              sm: 200, // Small screens (tablets)
              md: 550, // Laptops
              xl: 700, // Desktops
            },
            overflowY: "auto",
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Reg No</TableCell>
                <TableCell>Book No</TableCell>
                <TableCell>Reg Year</TableCell>
                <TableCell>Page</TableCell>
                {!isScanned && <TableCell>Reg Date</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.regno}</TableCell>
                    <TableCell>{row.bookno}</TableCell>
                    <TableCell>{row.regyear}</TableCell>
                    <TableCell>{row.page}</TableCell>
                    {!isScanned && (
                      <TableCell>{row.regdate?.split("T")[0]}</TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={isScanned ? 4 : 5} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );

  return (
    <>
      {loading && <ApiLoader />}
      <div className="flex h-screen">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <Header />
          <div className="flex flex-1">
            <div className="flex-1 align-middle justify-center">
              <ThemeProvider theme={theme}>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ marginBottom: 2 }}
                >
                  <Grid item>
                    <TextField
                      label="From Date"
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="To Date"
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleFetchData}
                    >
                      Search
                    </Button>
                  </Grid>
                </Grid>

                {error ? (
                  <Typography color="error" align="center">
                    {error}
                  </Typography>
                ) : (
                  <Grid container spacing={2}>
                    {renderTable("SCANNED DOCUMENT", scannedData, true)}
                    {renderTable("NOT SCANNED DOCUMENT", notScannedData, false)}
                  </Grid>
                )}
              </ThemeProvider>
            </div>
            <div className="w-64 h-full">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListOfScanDocumentsDatewise;
